import { InjectionToken } from '@angular/core';

export interface AppConfig {
  i18n: boolean;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('isophi.app.config');
